export default __webpack_public_path__ + "static/media/nomad-logo-horizontal.603beb47.png";